import { getInvestorStats } from '@lib/api-services/suburbProfileService'
import { useState, useEffect } from 'react'

/**
 * Custom hook to fetch investor statistics for a suburb with optional filters
 * @param {string} slug - Suburb slug
 * @param {string} type - Type filter ('house', 'unit', or '')
 * @param {string} bedrooms - Bedrooms filter ('Overall', '1', '2', '3', '4', '5+')
 * @param {Object} initialData - Initial investor statistics data from server-side props
 * @returns {Object} { investorStats, isLoading, error }
 */
function useInvestorStatistics(
  slug,
  bedrooms = 'Overall',
  initialData = null
) {
  const [investorStats, setInvestorStats] = useState(initialData)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!slug) {
      setInvestorStats(initialData)
      return
    }

    const hasFilters = bedrooms
    if (!hasFilters) {
      setInvestorStats(initialData)
      return
    }

    const fetchFilteredData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const params = {}
        if (bedrooms) params.bedrooms = bedrooms

        const response = await getInvestorStats(slug, params)
        setInvestorStats(response)
      } catch (err) {
        console.error('Error fetching filtered investor statistics:', err)
        setError(err)
        if (initialData) {
          setInvestorStats(initialData)
        }
      } finally {
        setIsLoading(false)
      }
    }

    fetchFilteredData()
  }, [bedrooms, slug, initialData])

  useEffect(() => {
    const hasFilters = bedrooms
    if (initialData && !hasFilters) {
      setInvestorStats(initialData)
    }
  }, [initialData, bedrooms])

  return { investorStats, isLoading, error }
}

export default useInvestorStatistics

